const KEY = "sw_onboarding_org_admin_llm_draft";

/** Save org-admin LLM onboarding draft after PUT /settings/llm (no raw api_key). */
export function saveOnboardingLlmDraft(responseBody) {
  if (!responseBody || typeof responseBody !== "object") return;
  try {
    const snapshot = {
      llm_type: responseBody.llm_type,
      llm_provider: responseBody.llm_provider ?? null,
      is_byo_llm_enabled: !!responseBody.is_byo_llm_enabled,
      openai_key: responseBody.openai_key
        ? {
            exists: !!responseBody.openai_key.exists,
            last_4: responseBody.openai_key.last_4 ?? null,
            last_rotated_at: responseBody.openai_key.last_rotated_at ?? null,
          }
        : { exists: false, last_4: null },
    };
    localStorage.setItem(KEY, JSON.stringify(snapshot));
  } catch {
    /* quota / private mode */
  }
}

export function readOnboardingLlmDraft() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearOnboardingLlmDraft() {
  try {
    localStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}
